import { render, staticRenderFns } from "./ParentsAuthorization.vue?vue&type=template&id=64acb788&scoped=true"
import script from "./ParentsAuthorization.vue?vue&type=script&lang=js"
export * from "./ParentsAuthorization.vue?vue&type=script&lang=js"
import style0 from "./ParentsAuthorization.vue?vue&type=style&index=0&id=64acb788&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64acb788",
  null
  
)

export default component.exports